<template>
  <div class="color-scheme__select">
      <select :value="selectedValue" @change="setValue($event.target.value)">
      <option :selected="option.id === selectedValue" v-for="option in options" :key="'option-' + option.id" :value="option.id" >{{option.label}}</option>
    </select>
    <div class="color-square" v-for="color in colors" :title="color.label" :key="color.key" :style="{'background-color': color.value}">
      <color-picker v-if="selectedValue.includes('custom-color')" label="" :value="color.value" :colorScheme="color.key" @pickHex="onPickSchemeColor" />
    </div>
  </div>
</template>

<script>
import ColorPicker from "../core/colorPicker";
import configUtils from "./../../utils/configs.js"
import { mapActions } from 'vuex'
export default {
  name: "colorSchemeSelect",
  props: ["modelItem", "value", "options"],
    components: {
    "color-picker": ColorPicker
  },
  created() {
    console.log("colorSchemeSelect", this.value)
    this.selectedValue = this.value ? this.value : this.options[0].id
    this.updateSelection(this.selectedValue)
    this.setValue(this.selectedValue)
  },
  data() {
    return {
      colors: [],
      selectedValue: null
    }
  },
  watch: {
    'value': 'updateSelection'
  },
  methods: {
    ...mapActions(['updateColorScheme']),
    updateSelection(newVal) {
        this.selectedValue = newVal
        this.colorSchemes = this.$store.state.user.colorSchemes
        this.colors = this.colorSchemes[newVal]
    },
    setValue(value) {
      this.selectedValue = value
      console.log('onColorSchemeSelect', value)
      this.colors = this.colorSchemes[value] || []
      if (value === "" || !value) {
        this.selectedOption = null;
      }
      var val = {
        key: value,
        colors: []
      }

      this.colors.map((color) => {
        val.colors.push(color.value)
      })

      this.modelItem.value = val
      this.$emit("pick", this.modelItem.value);
    },
    onPickSchemeColor(value) {
      this.colors.map((c) => {
        if(c.key === value.key) {
          c.value = value.color
        }
      })
      this.setValue(this.selectedValue)
      this.colorSchemes[this.selectedValue] = this.colors
      this.updateColorScheme(this.colorSchemes)
    }
  }
};
</script>
